module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hMrLl"))).then(() => parcelRequire('fThBo'));